import { styled } from 'libs/ui/styled';

export const FieldsStyled = styled('div')<{ gap: number }>(({ gap }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap,

  '.chunkedRow-emptySpace': {
    flex: 1,
  },
}));
